'use client'

const Card: React.FunctionComponent<{
  children: React.ReactNode
}> = ({ children }) => {
  return <div className="bg-secondary p-4">{children}</div>
}

export default Card
